import { IdentificationForm } from './IdentificationForm';

export default IdentificationForm;
